import React from 'react';
import './About.css';

const About = () => {
  const stats = [
    { number: '10+', label: 'Libraries Served' },
    { number: '5+', label: 'Years Experience' },
    { number: '99.9%', label: 'Uptime Guarantee' },
    { number: '24/7', label: 'Support Available' }
  ];

  const values = [
    {
      icon: '🎯',
      title: 'Innovation',
      description: 'We leverage cutting-edge technology to provide modern, efficient library management solutions.'
    },
    {
      icon: '🤝',
      title: 'Partnership',
      description: 'We build long-term partnerships with our clients, providing ongoing support and innovation.'
    },
    {
      icon: '💡',
      title: 'Efficiency',
      description: 'Our solutions reduce manual intervention and improve operational efficiency in library management.'
    },
    {
      icon: '🛡️',
      title: 'Reliability',
      description: 'We provide secure, scalable hosting services ensuring easy access and system integration.'
    }
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">About ELIBS SOLUTIONS</h2>
            <p className="about-description">
              ELIBS SOLUTIONS (PVT) LTD is a specialized provider of comprehensive library automation solutions. 
              Our mission is to help institutions streamline library operations using innovative, efficient, 
              and scalable technologies. We support libraries in delivering exceptional services through 
              seamless cataloguing, circulation, and digital resource management solutions.
            </p>
            <p className="about-description">
              We provide customized solutions to enhance operational efficiency, improve resource accessibility, 
              and create a more interactive and user-friendly library experience. Our team of experienced 
              professionals is dedicated to delivering state-of-the-art, scalable solutions that enhance 
              library resources globally.
            </p>
            
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-card">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="about-visual">
            <div className="visual-card">
              <div className="card-header">
                <h3>Our Expertise</h3>
              </div>
              <div className="expertise-list">
                <div className="expertise-item">
                  <div className="expertise-icon">📚</div>
                  <div className="expertise-content">
                    <h4>Library Automation</h4>
                    <p>Efficient cataloguing and circulation systems</p>
                  </div>
                </div>
                <div className="expertise-item">
                  <div className="expertise-icon">💻</div>
                  <div className="expertise-content">
                    <h4>Digital Resource Management</h4>
                    <p>E-resources, digitization, and digital content access</p>
                  </div>
                </div>
                <div className="expertise-item">
                  <div className="expertise-icon">☁️</div>
                  <div className="expertise-content">
                    <h4>Cloud-based Hosting</h4>
                    <p>Secure and scalable hosting for library systems</p>
                  </div>
                </div>
                <div className="expertise-item">
                  <div className="expertise-icon">🎯</div>
                  <div className="expertise-content">
                    <h4>Consulting Services</h4>
                    <p>Expert advice for library systems and policies</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="values-section">
          <h3 className="values-title">Our Core Values</h3>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h4 className="value-title">{value.title}</h4>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
